import { NamedEntityDto } from './named.dto';

export class DiagnosticDifficultyDto extends NamedEntityDto {}
